import { render, staticRenderFns } from "./UpdateWifi.vue?vue&type=template&id=0f571d1c&scoped=true"
import script from "./UpdateWifi.vue?vue&type=script&lang=js"
export * from "./UpdateWifi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f571d1c",
  null
  
)

export default component.exports